import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ScrollToTop } from "./components/ScrollToTop";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Home from "./pages/Home";
import Motorcycles from "./pages/Motorcycles";
import CarWash from "./pages/CarWash";
import Maintenance from "./pages/Maintenance";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import ReserveNow from "./pages/ReserveNow";
import Gallery from "./pages/Gallery";
import Locations from "./pages/Locations";
import Blog from "./pages/Blog";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/motorcycles" element={<Motorcycles />} />
            <Route path="/reserve" element={<ReserveNow />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/services/car-wash" element={<CarWash />} />
            <Route path="/services/maintenance" element={<Maintenance />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <WhatsAppFloat />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
